/* eslint-disable jsx-a11y/label-has-associated-control */
import React, {
    useRef, useState, useEffect, useContext,
    useCallback, 
} from "react";
import { FormValidateContext } from "@root/context/form-validate";
import BaseInput from "../base-input";

const { v4: uuidv4 } = require("uuid");

const InputField = ({ marker, type = "text", value, label, required, min, max, onChange, onBlur, onFocus, suffix, placeholder, textarea, inputId, error, readOnly = false, customValidation }) => {
    const [suffixWidth, setSuffixWidth] = useState(0);
    const fieldRef = useRef(null);
    const suffixRef = useRef(null);
    const [_id] = useState(uuidv4());

    const { registerField, unregisterField, getFieldError, clearFieldError } = useContext(FormValidateContext) || {};

    useEffect(() => {
        if (suffix) {
            setSuffixWidth(suffixRef.current.offsetWidth);
        }
    }, [suffix]);

    const validate = useCallback(() => {

        if (customValidation && typeof customValidation === "function") {
            const customError = customValidation(value);
            if (customError) {
                return customError;
            }
        }

        if (required && !value) {
            return "This field is required";
        }
        if (typeof min !== "undefined") {
            if (+value < min) {
                return `Minimum should be ${min}`;
            }
        } 
        if (typeof max !== "undefined") {
            if (+value > max) {
                return `Maximum should be ${max}`;
            }
        }

        return true;
    }, [required, min, max, value, customValidation]);

    useEffect(() => {
        registerField?.({
            id: _id, validate, ref: fieldRef,
        });

        return () => {
            unregisterField?.({ id: _id });
        };
    }, [label, validate, value]);

    const fieldError = getFieldError?.(_id) || error;

    const clampNumberToMinMax = ($value) => {
        if ($value === "") return $value;
        let numericValue = Number($value);
        if (min !== undefined && numericValue < min) {
            numericValue = min;
        }
        if (max !== undefined && numericValue > max) {
            numericValue = max;
        }
        return String(numericValue);
    };

    const handleChange = (event) => {
        clearFieldError(_id);
        let newValue = event.target.value;

        if (type === "number") {
            newValue = clampNumberToMinMax(newValue);
            // eslint-disable-next-line no-param-reassign
            event.target.value = newValue;
        }

        onChange(event);
    };

    const handleBlur = (event) => {
        if (onBlur) {
            onBlur(event);
        }
        const fieldValid = validate();
        if (fieldValid === true) {
            clearFieldError(_id); 
        }
    };

    return (
        <div className="input-field" style={{ "--suffix-width": `${suffixWidth}px` }}>
            <BaseInput
                label={label}
                required={required}
                marker={marker}
                error={fieldError ? fieldError?.message : false}
            >
                <div
                    className={`input-field__input ${fieldError ? "input-field__input--invalid" : ""}`}
                    ref={fieldRef}
                >
                    {textarea ? (
                        <textarea type={type} value={value} onChange={handleChange} placeholder={placeholder} onBlur={handleBlur} onFocus={onFocus} readOnly={readOnly} id={inputId} />
                    ) : (
                        <input
                            readOnly={readOnly}
                            type={type}
                            value={value}
                            {...(type === "number" && { min, max })}
                            onChange={handleChange}
                            placeholder={placeholder}
                            onBlur={handleBlur}
                            onFocus={onFocus}
                            onWheel={(event) => event.target.blur()}
                            id={inputId}
                        />
                    )}
                    {suffix ? (
                        <span className="input-field__input-suffix" ref={suffixRef}>{suffix}</span>
                    ) : null}
                </div>
            </BaseInput>
        </div>

    );
};
export default InputField;
